import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import { InvoiceModel }                      from '../invoices/models/invoice';
import { StripePaymentErrorCallbackModel }   from './models/stripe.payment.error-callback';
import { StripePaymentResponseModel }        from './models/stripe.payment-response';
import { StripePaymentSuccessCallbackModel } from './models/stripe.payment.success-callback';

@Component({
  selector   : 'wor-stripe-payment',
  template: require('./stripe.payment.component.html')
})
export class StripePaymentComponent implements AfterViewInit, OnDestroy, OnInit {
  private card    : stripe.elements.Element;
  private elements: stripe.elements.Elements;
  public  error   : string;
  private stripe  : stripe.Stripe;

  @Input() accountId  : string;
  @Input() invoice    : InvoiceModel;
  @Input() publicKey  : string;
  @Input() submitEvent: string;

  @Output() onError   : EventEmitter<StripePaymentErrorCallbackModel>   = new EventEmitter();
  @Output() onSuccess : EventEmitter<StripePaymentSuccessCallbackModel> = new EventEmitter();

  @ViewChild('stripeCardComponent') cardElement : ElementRef<Element>;

  constructor (
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit () : void {
    this.card.mount(this.cardElement.nativeElement);

    this.card.on('change', ( evt ) => {
      this.error = evt.error
        ? evt.error.message
        : '';

      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy () : void {


    window[ this.submitEvent || 'collectStripePayment' ] = null;


  }

  ngOnInit () : void {
    this.stripe = Stripe(this.publicKey, {
      stripeAccount: this.accountId
    });

    this.elements = this.stripe.elements();
    this.card     = this.elements.create('card');

    window[this.submitEvent || 'collectStripePayment'] = () => {
      this.stripe.confirmCardPayment(this.invoice.stripe_client_secret, {
        payment_method: {
          card: this.card
        }
      })
      .then(( result : StripePaymentResponseModel ) => {
        if (result.error) {
          console.error(result.error);

          if (this.onError) {


            this.onError.emit({ error: result.error });


            };


          }
        else {
          if (this.onSuccess) {

            this.onSuccess.emit({ intent: result.paymentIntent });

            };

          }
      });
    };
  }
}
